"use strict";
/**
 * Implementation for the transport interface. This is used to send the plcWrite request to INAX.
 * @class PlcWriteTransportPack
 * @author insite-gmbh
 */
class PlcWriteTransportPack {
}
exports.PlcWriteTransportPack = PlcWriteTransportPack;
